<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.purchaseorder') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.status == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.status == 'padding'"
                    class="badge badge-warning">{{ $t('status.po.padding') }}</span>
                  <span
                    v-if="query.status == 'rejected'"
                    class="badge badge-danger">{{ $t('status.po.rejected') }}</span>
                  <span
                    v-if="query.status == 'uncompleted'"
                    class="badge badge-info">{{ $t('status.po.uncompleted') }}</span>
                  <span
                    v-if="query.status == 'completed'"
                    class="badge badge-success">{{ $t('status.po.completed') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        class="text-warning"
                        value="padding">
                        {{ $t('status.po.padding') }}
                      </option>
                      <option
                        class="text-danger"
                        value="rejected">
                        {{ $t('status.po.rejected') }}
                      </option>
                      <option
                        class="text-info"
                        value="uncompleted">
                        {{ $t('status.po.uncompleted') }}
                      </option>
                      <option
                        class="text-success"
                        value="completed">
                        {{ $t('status.po.completed') }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.po') }}</th>
              <th class="no-sort">{{ $t('message.vendor') }}</th>
              <th class="no-sort">{{ $t('message.productlist') }}</th>
              <th class="no-sort">{{ $t('documents.pr') }}</th>
              <th class="no-sort">{{ $t('documents.pe') }}</th>
              <th class="no-sort">{{ $t('documents.gr') }}</th>
              <th>{{ $t('message.debttotal') }}</th>
              <th>{{ $t('message.paidtotal') }}</th>
              <th>{{ $t('message.grandtotal') }}</th>
              <th>{{ $t('message.scheduled_at') }}</th>
              <th
                class="no-sort"
                style="max-width: 100px;">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="purchases.length === 0"
                colspan="11"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in purchases"
              :key="index">
              <td :data-order="item.po_id">
                <router-link-custom
                  :to="{name: 'PurchaseOrderEdit', query: {
                    id: item.po_id,
                    code: item.po_code
                  }}"
                  :text="item.po_code"
                  :to_appid="4"
                  :current_appid="4"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.vendor"
                  :to="{name: 'ContactVendorEdit', query: {ven_id: item.vendor.vendor_id, ven_name: item.vendor.vendor_name}}"
                  :text="item.vendor.vendor_name"
                  :to_appid="11"
                  :current_appid="4"
                  :disabled="item.vendor.is_deleted == true" />
              </td>
              <td style="vertical-align: top;">
                <item-list :orders="item.orders" />
              </td>
              <td style="vertical-align: top;">
                <router-link-custom
                  v-if="item.reference.purchase_requisition"
                  :to="{name: 'PurchaseRequisitionEdit', query: {
                    id: item.reference.purchase_requisition.po_id,
                    code: item.reference.purchase_requisition.po_code,
                  }}"
                  :text="item.reference.purchase_requisition.po_code"
                  :status="{
                    text: getPRStatus(item.reference.purchase_requisition, item, $t, mixin).message,
                    color: getColorFormStatus(getPRStatus(item.reference.purchase_requisition, item, $t, mixin).status),
                    type: 'icon',
                  }"
                  :to_appid="12"
                  :current_appid="4"/>
              </td>
              <td style="vertical-align: top;">
                <div
                  v-for="(payment, index_) in item.reference.payments"
                  :key="index_">
                  <router-link-custom
                    :to="{name: 'AccountsPaymentEntryEdit', query: {
                      pe_id: payment.pe_id,
                      pe_code: payment.pe_code
                    }}"
                    :text="payment.pe_code"
                    :status="{
                      text: getPaymentStatus(payment, $t).message,
                      color: getColorFormStatus(getPaymentStatus(payment, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="4"
                    :current_appid="4"/>
                </div>
              </td>
              <td style="vertical-align: top;">
                <div
                  v-for="(goodsreceipt, index_) in item.reference.goodsreceipts"
                  :key="index_">
                  <router-link-custom
                    :to="{name: 'GoodsReceiptEdit', query: {
                      gr_id: goodsreceipt.gr_id,
                      gr_code: goodsreceipt.gr_code
                    }}"
                    :text="goodsreceipt.gr_code"
                    :status="{
                      text: getGoodsReceiptStatus(goodsreceipt, $t).message,
                      color: getColorFormStatus(getGoodsReceiptStatus(goodsreceipt, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="3"
                    :current_appid="4"/>
                </div>
              </td>
              <td :data-order="getDebtPurchaseAmount(item)">
                {{ getNumber(getDebtPurchaseAmount(item)) }}
              </td>
              <td :data-order="getPaidAmount(item.reference.payments)">
                {{ getNumber(getPaidAmount(item.reference.payments)) }}
              </td>
              <td :data-order="getTotal(item.orders).payment">
                {{ getNumber(getTotal(item.orders).payment) }}
              </td>
              <td :data-order="item.scheduled_at">
                {{ getDate(item.scheduled_at) }}
              </td>
              <td style="max-width: 100px;">
                <template>
                  <span
                    v-if="getPurchaseStatus(item, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getPurchaseStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPurchaseStatus(item, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getPurchaseStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPurchaseStatus(item, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getPurchaseStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getPurchaseStatus(item, $t, mixin).message }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      purchases: 'getPurchases',
      getPurchaseStatus: 'getPurchaseStatus',
      getPRStatus: 'getPRStatus',
      getPaymentStatus: 'getPaymentStatus',
      getGoodsReceiptStatus: 'getGoodsReceiptStatus',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.purchases.title'),
      current: {
        app_name: 'purchases',
        app_id: 4,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearPurchases'])
  },
  methods: {
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getPurchases', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        status: (() => {
          return this.query.status !== 'all'
            ? this.query.status
            : null
        })(),
        doc_type: 'po',
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/po/All.vue